import React from "react";
import { useSelector } from "react-redux";
import User from "./index";
import Manager from "./Manager";
const RouteDashboard = () => {
  const { user } = useSelector(state => state);
  switch (user.role) {
    case "manager":
      return <Manager />;
      break;
    case "user":
      return <User />;
      break;
    case "classmanager":
      return <User />;
    default:
      break;
  }
  return <div>RouteDashboard</div>;
};

export default RouteDashboard;
